import React, { useState } from "react";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrainSubway, faTrain } from "@fortawesome/free-solid-svg-icons";
import { VARIANT_OPTIONS } from "../../constants/login";
import "../../styles/loginStyles.scss";

type Props = {
	onSelect: (variant: string) => void;
};

const ICON_MAP: Record<string, any> = {
	trainSubway: faTrainSubway,
	train: faTrain,
};

function VariantSelector({ onSelect }: Props) {
	const [selected, setSelected] = useState<string>(VARIANT_OPTIONS[0].key);

	const handleContinue = () => {
		onSelect(selected);
	};

	return (
		<div className='variantSelector__container'>
			<p className='loginStyles__homeLogin' style={{ fontSize: "18px", marginBottom: "4px" }}>
				Select Your System
			</p>
			<p style={{ color: "#888", fontSize: "13px", marginBottom: "20px" }}>
				Choose the platform you want to access
			</p>

			<div className='variantSelector__toggle'>
				{VARIANT_OPTIONS.map((opt) => {
					const isActive = selected === opt.key;
					return (
						<button
							key={opt.key}
							type='button'
							className={`variantSelector__option ${isActive ? "variantSelector__option--active" : ""}`}
							onClick={() => setSelected(opt.key)}
						>
							<FontAwesomeIcon
								icon={ICON_MAP[opt.icon]}
								className='variantSelector__icon'
							/>
							<span className='variantSelector__label'>{opt.label}</span>
						</button>
					);
				})}
				<div
					className='variantSelector__slider'
					style={{
						transform: selected === VARIANT_OPTIONS[0].key ? "translateX(0)" : "translateX(100%)",
					}}
				/>
			</div>

			<Button className='buttonStyle__1 mt-4' style={{ width: "100%" }} onClick={handleContinue}>
				Continue
			</Button>
		</div>
	);
}

export default VariantSelector;
